import ProjectData from '@/data/ProjectData.ts'

export default [
  new ProjectData("project-7", "Immersive (XR | AR | VR)", "img/projects/vr-cardiologist-sim-female.gif", `
  
  <div class="paragraph">
            <div class="hc-title">VR Operating Room - Quest 2 Experience</div>
            This immersive VR experience demonstrates controller-less interaction via a Meta/Oculus/Quest 2 headset using just your hands.
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/s9CouHB1Vqo?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
            
           
                <hr>
  
                </div>
  
  <div class="paragraph">
            <div class="hc-title">Beat Boxer: VR Rhythm Game</div>
            Whose VR portfolio would be complete without a Beat Saber-inspired prototype? 🙂<br>
            In this Quest 2 VR game, punch your way to fitness while listening to some great jams. Coming soon!
            
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/z9MC428nexc?rel=0" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>Scriptable objects to easily change out your song</li>
        <li>Oculus Integration SDK</li>
        <li>Cube spawn rate that corresponds to your chosen song's beats per minute (bpm)</li>
        <li>Custom post processing effects for VR using Global Volume on URP</li>
        </ul>
    </div>
    <hr>
          
</div>

  <div class="paragraph">
  <div class="hc-title">HoloLens 2 Electronics Repair Simulator</div>
      I was responsible for maintaining and evolving a Unity HoloLens 2 app used for training technicians to repair individual electronic assemblies in radar systems. Each module/mesh is a digital twin created in Creo then imported as an FBX into Unity. Because it's export controlled info, I'm not allowed to show the actual parts, but experimented with a redacted version using dummy PCB assemblies I downloaded from <strong><a href="https://sketchfab.com/">Sketchfab</a></font></strong> before I left.
      <br>
      <!--
      <div class="paragraph center">
      <iframe class="youtube" src="https://www.youtube.com/embed/1DJTug3vJa8?rel=0" frameborder="0" allowfullscreen></iframe>
      </div>
      -->

          <div class="paragraph">
            Main features :
            <ul>
            <li>Voice commands</li>
            <li>3D Parts highlighting</li>
            <li>Corresponding 2D parts diagrams</li>
            </ul>
        
        <!--<div class="paragraph center">
          <img class="pc-screenshot" src="img/projects/hololens2.gif" alt="Dreamland Screenshot" />
          <img class="pc-screenshot" src="img/projects/hololens4.gif" alt="Dreamland Screenshot" />
        </div>-->
        
        <!--Responsibilities and technical aspects covered :
        <ul>
        <li>Built prefabs for every module from scratch, meticulously labeling each part for speech recognition</li>
        <li>Deploy and test on HoloLens 2 headset</li>
        <li>Editor tools to combine submeshes into a single mesh for proper highlighting</li>
        <li>Combined materials into single texture atlases</li>
        <li>Parts highlighting accomplished using the Outline component</li>
        <li>General bug fixes</li>
        <li>Vuforia Image Targets</li>  
        </ul>
        -->
    </div>
  <hr>
  
</div>

<div class="paragraph">
            <div class="hc-title">Marvel - Eternals Augmented Reality</div>
            
            As a huge Marvel fan, it was a dream come true to be part of the team working on these Happy Meal Box AR experiences.

            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/lYnOOM9K3EY?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>

            Here, I am testing out how Ikaris' idle [flying] animation spawns in my flower bed.<br>
            
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/iyQKrAZ7uu0?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
                <hr>
  
                </div>

<div class="paragraph">
<div class="hc-title">VR Archery Training*</div>
    <div class="paragraph">
    Ever wanted to live vicariously as Hawkeye? Now you can! 
    </br>
    </br>
    Strap on your Oculus/Quest 2 headset and grab your bow to practice your archery skills at the secret Avengers Training Facility! Say hi to Natasha while you're there.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/XPhFpF0X1MM?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
    Some technical aspects covered during development :
        <ul>
        <li>3D Modeling, UVs, and Texturing</li>
        <li>Building for Oculus Quest (OpenXR)</li>
        <li>Casting to Google Chrome</li>
        </ul>
    </div>
    <div class="paragraph">
      <div class="notice">
        Source code available on <a href="https://github.com/marvelasDev/VR_SecretTrainingHQ" target="_blank">GitHub</a>.
      </div><br>
      * also featured under Rapid Prototyping section
    </div>
    <hr>
    
  
    </div>

<div class="paragraph">
<div class="hc-title">Suit Up with Spider-Man Augmented Reality Game</div>
    <div class="paragraph">
    During my time at Creata, we partnered with Kellogg's (now called Kellanova) to create this unique<strong> AR </strong> endless [runner] mobile game. Using Vuforia image tracking of a licensed printed Spider-Man <strong>(Spidey Sensor)</strong>, players used this cutout to move an onscreen reticle like a <strong> joystick</strong> to swing Spidey through New York, London, and Venice. "How?" you ask. See for yourself below with this video from an independent reviewer. 
     <br>
     
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/0HwnzLER3xk?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    The results were <strong>astounding</strong>&#8212;almost 680K total installs across iOS and Android in the nine months the program ran, making it Kellogg's second-most downloaded app <strong>ever</strong>. We endeared ourselves to our long time client by adding value to printed cardboard inserts (found in Frosted Flakes, Pop Tarts, Eggos, etc.)
    </div>
    <hr>
    
  
    </div>

<div class="paragraph">
<div class="hc-title">Winery Tale - AR Menu</div>
My submission for a Winery Tale design contest. While everyone else was making pirates and Prohibition-era gangsters come to life on alcohol bottles, I was turning the bottle into essentially a handheld controller (a la Oculus/Quest) to drive AR menu navigation<br>

<div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/8I2ebVJM9aU?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
    Features :
    <ul>
    <li>Vuforia cylindrical target</li>
    <li>Winery videos</li>
    <li>Rotate the wine bottle to highlight the menu tiles</li>
    </ul>  
    </div>
    <hr>
  
    </div>
    
    <div class="paragraph">
    <div class="hc-title">Millennium Park VR Defender</div>
    Ever been to Chicago's Cloud Gate aka The Bean? Well, rumor has it aliens are jealous of its beauty and thus want to destroy it (joking). Use your headset to navigate around Millennium Park Chicago and defend the Bean at all costs!<br>
    
    <div class="paragraph center">
            <iframe class="youtube" src="https://www.youtube.com/embed/6dQRCMEc5Y4?rel=0" frameborder="0" allowfullscreen></iframe>
        </div>
        Features :
        <ul>
        <li>Waypoint navigation via Gaze Input or pressing your HMD button</li>
        <li>360-degree photos help you feel you are there in person</li>
        <li>Playable 3D Space Invaders Easter egg</li>
        <li>Fun older personal Unity project I made to learn VR
        </ul>  
        </div>
      <hr>
  
        </div>
        
        <div class="paragraph">
        <div class="hc-title">Virtual Car Dealership: PlayCanvas</div>
        I created this virtual car showroom in PlayCanvas. After stepping away from it for a while, I had forgotten just how powerful WebGL was. As for PlayCanvas, it's tantamount to using Unity in a browser, basically. It's even well-supported by VS Code.<br>
        
        <div class="paragraph center">
                <iframe class="youtube" src="https://www.youtube.com/embed/qdUh8PlTTUE?rel=0" frameborder="0" allowfullscreen></iframe>
            </div>
           
        </div>
            <hr>
  
            </div>
            
            <div class="paragraph">
            <div class="hc-title">Ninja VR Simulator</div>
            Simple Unity VR minigame for a sticker & toys company, designed for Google Cardboard. This ninja shuriken-throwing exercise was unlockable via scanning certain stickers.<br>
            
            <div class="paragraph center">
                    <iframe class="youtube" src="https://www.youtube.com/embed/ZQEAigGm3H0?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
                <hr>
  
                </div>
                

<div style="clear:both"></div>
</div>

</div>
`, "#1ca1e2", true, true),
new ProjectData("project-6", "Mobile Apps", "img/projects/dreamland-icon.gif", `
  <div class="paragraph">
  <div class="hc-title">Dreamland</div>
      I worked at a biotech startup on a large digital therapeutic app named <strong>Dreamland</strong> which was categorized as <strong>psychological oncology</strong> . The app was a first-of-its kind prescription-only digital therapeutic to treat the anxiety and depressive symptoms in patients recently diagnosed with a rare&#8212;but deadly&#8212;form of blood cancer called Acute Myeloid Leukemia (AML) using meditation, in-app social interaction, and other treatment modalities. </div>

      <div class="paragraph center">
      <iframe class="youtube" src="https://www.youtube.com/embed/XuEmJgVpMec?t=10?rel=0" frameborder="0" allowfullscreen></iframe>
      </div>

          <div class="paragraph">
            Milestones and Main features :
            <ul>
            <li>Granted <strong>Breakthrough Designation</strong> by the FDA</li>
            <li>Disease expertise and content provided by our SME, a physician at Massachusetts General</li>
            <li>Minigames to educate patients on the disease</li>
            <li>5 weekly sessions</li>
            <li>Encouraging video and audio from existing AML survivors</li>
            <li>Meditation and mindfulness exercises</li>
            <li>Positive reinforcement and access to live support</li>
            </ul>
        

        <div class="paragraph center">
          <img class="pc-screenshot" src="img/projects/dreamland1.png" alt="Dreamland Screenshot" />
          <img class="pc-screenshot" src="img/projects/dreamland-icon2.gif" alt="Dreamland Screenshot" />
        </div>
        My new features and responsibilities :
        <ul>
        <li>Created Lip-Sync component for the Guide avatar (see video at top)</li>
        <li>C# programming of an offline patient survey data capture tool that saves their answers to a queue until an internet connection is re-established</li>
        <li>Added the ability to 'Skip' any minigames</li>
        <li>Consume RESTful APIs to communicate with a postgreSQL backend</li>
        <li>MVP bug fixes, pair programming, and code refactoring</li>
        <li>Made the UI responsive (it was clearly only designed for older, lower-resolution iPads)</li>
        
        </ul>

        
    </div>  
  <hr>
  <br>
  <div class="hc-title">Meaning Centered Psychotherapy</div>
  <div class="paragraph">
  Serein, or as we called it internally, MCP, was another existing digital therapeutic app MVP originally developed externally, with a large codebase (and a buggy one, at that). The app's theme is meaning-centered psychotherapy for later-stage cancer patients. In it, you play as one of 17 different bird species who try to manifest meaning and gratitude throughout their journey around an epic, visually stunning 3D world.
  </br>
  </br>
  </div>
  <div class="paragraph center">
      <iframe class="youtube" src="https://www.youtube.com/embed/sL-ZdMD_gOs?rel=0" frameborder="0" allowfullscreen></iframe>
  </div>
  <div class="paragraph">
  Some technical aspects covered during development :
      <ul>
      <li>Scriptable objects</li>
      <li>Additive scene loading</li>
      <li>Squared magnitude for measuring the distance between your bird and clicked screen destination</li>
      <li>Bird animation controllers (Mecanim)</li>
      </ul>
  </div>

  <div class="paragraph">
  Noteworthy bug fixes :
      <ul>
      <li>Resolved a navmesh locomotion edge case bug that occasionally prevented the main character's Mecanim transition back to Idle, an issue the original dev studio could not fix</li>
      <li>Anchored the beginning of longer character dialogue text to the top of the chat bubble</li>
      <li>Fixed character conversations not loading due to a backend timeout from DialogFlow (Google's chat LLM) </li>
      <li>Fixed trigger-activated interactables not responding to collision</li>
      <li>Some materials were not rendering on Windows builds</li>
      </ul>
  </div>
  <div class="paragraph center">
      <iframe class="youtube" src="https://www.youtube.com/embed/90DhRLHpJz0?rel=0" frameborder="0" allowfullscreen></iframe>
  </div>
  <hr>
<br>
  <div class="hc-title">Clevermind</div>
  <div class="paragraph">
   I wrote <strong>Clevermind</strong> in C# and Xamarin for with a client whose father had Alzheimers. The patient's wife was the main caregiver. The idea was multifold: 1) Try to increase neuroplasticity via brain games. 2) Offer caregivers an occasional well-deserved respite by keeping the patient occupied. 3) Consolidate all the end-user's social media apps, news apps, and games into a central source. 4) Prevent unintended purchases, and 5) Prolong the independence of seniors suffering from dementia for as long as possible. This was the first greenfield app I've ever had the pleasure of coding.
   <br>
   <div class="paragraph center">
   <iframe class="youtube" src="https://www.youtube.com/embed/XsOIDHNl1as?rel=0" frameborder="0" allowfullscreen></iframe>
</div>
  Features and Accolades:
      <ul>
      <li>Featured on <a href="https://patient-innovation.com/post/7108/">PatientInnovation.com</a>.</font></li>
      <li>Named one of the best Alzheimer's apps on <a href="https://www.apppicker.com/reviews/18622/clevermind-app-review-helping-seniors-through-cognitive-impairment-issues/">Appicker</a></font> (2014)</li>
      <li>Patient-friendly interface with large buttons and accessibility features</li>
      <li>An robotic AI Assistant named MYIRA (My Intelligent Robotic Assistant), that responded to voice commands, 10 years before AI took the world by storm</li>
      <li>Javascript Puzzle and Brain Games</li>
      <li>Medication reminders</li>
      <li>Weather widget</li>
      </ul>
      </div>
      <div class="paragraph center">
      <img class="pc-screenshot" src="img/projects/clevermind1.png" alt="Clevermind Screenshot" />
      <img class="pc-screenshot" src="img/projects/clevermind2.png" alt="Clevermind Screenshot" />
    </div>
  
  <div class="paragraph">
  Some technical aspects covered during development :
      <ul>
      <li>Patient data tracking via SQL Server database</li>
      <li>Integration of the OpenEars speech recognition wrapper created by students at Carnegie Mellon</li>
      <li>Cross-communication between the core app's C# and Javascript inside embedded HTML webviews</li>
      <li>High score tracking</li>
      </ul>
  </div>
  <div class="paragraph center">
      <img class="pc-screenshot" src="img/projects/clevermind5.png" alt="Clevermind Screenshot" />
      <img class="pc-screenshot" src="img/projects/clevermind4.png" alt="Clevermind Screenshot" />
    </div>
    `, "#109c1b", true, false),
new ProjectData("project-8", "Bluetooth | BLE | Phygital", "img/projects/beatbugs-icon.png", `
<div class="paragraph">
      <div class="hc-title">Beat Bugs, Chirp, and Alexa</div>
      I worked for a toy company that partnered with Chirp to use their advanced audio technology to give life to these Beat Bugs toys based on the popular Netflix show. We worked with Netflix to embed a hidden audio signal into certain episodes of Season 1, which was broadcast to TVs, smartphones, and Alexa. The signal picked up by these toys would enable them to sing and dance along to the current song.
      <br><br>
      In addition, we worked with an external vendor to develop a companion iPad app, <strong><a target="_blank" href="https://apps.apple.com/be/app/beat-bugs-alive/id1263358138/">Beat Bugs Alive</a>,</font></li></strong> whose songs the toys could also physically react and sing along to. More on that <strong><a target="_blank"
      href="https://hijinxtoys.com/singing-figures/">here</a>.</font></strong>
      
      <div class="paragraph center">
              <iframe class="youtube" src="https://www.youtube.com/embed/iTbS1q73lDU?rel=0" frameborder="0" allowfullscreen></iframe>
          </div>

          <div class="paragraph center">
          <img src="img/projects/beatbugs4.png" alt="BB Screenshot" style="width:720px;height:410px;">
        </div>

          <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/beatbugs1.png" alt="BB Screenshot" />
        <img class="phone-screenshot" src="img/projects/beatbugs3.jpeg" alt="BB Screenshot" />
        </div>

          Responsibilities :
          <ul>
          <li>Audio signal QA</li>
          <li>Minor bug fixes</li>
          <li>QA build distribution</li>
          <li>Publish app to Apple App Store</li>
          </ul>
          
          </div>
          <div class="paragraph center">
        <a href="https://apps.apple.com/be/app/beat-bugs-alive/id1263358138" target="_blank"><img src="img/projects/app-store-logo.png" alt="Play Store badge" /></a>
    </div>
<hr>
<br>
<div class="paragraph">
<div class="hc-title">Bluetooth - Death Star Run</div>
This prototype consists of me controlling an X-Wing's on-screen rotation using a BLE SensorTag I've embedded inside a plastic Millennium Falcon my employer also produced. The SensorTag ships with a unique IMU which is an Accelerometer, Magnetometer, and Gyroscope combined.
    <br>
   
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/Gyn73YrsIbs?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
  

        <div class="paragraph">
          Main features :
          <ul>
          <li>In-game laser gun that responds to button press on SensorTag</li>
          <li>3D Procedurally-generated Death Star level chunks (a la Temple Run) </li>
          </ul>
  </div>
<hr>
<br>
</div>

<div class="paragraph">
<div class="hc-title">Driving BumBLEbee using Custom MCU</div>
This was for our in-house toy company to show how we can marry their toys to Digital, and possibly sell more SKUs and apps as a result. The video shows me affecting Bumblebee's motion down a racetrack made in Unity, and using the pitch (for acceleration) and roll (for steering) on a custom-made BLE sensor (Note the brief setup and MAC addresses at the beginning).<br>

<div class="paragraph center">
      <iframe class="youtube" src="https://www.youtube.com/embed/q0YUTya5ccI?rel=0" frameborder="0" allowfullscreen></iframe>
  </div>

  <div class="paragraph center">
  <iframe class="youtube" src="https://www.youtube.com/embed/RIgby7uBs_s?rel=0" frameborder="0" allowfullscreen></iframe>
</div>

  Features and Responsibilities :
  <ul>
  <li>1 and 2 Player Modes</li>
  <li>Robust Unity game with 4 different tracks and 8 raceable characters</li>
  <li>Toy scanning to unlock cars for use in game</li>
  <li>Used in business pitches to Revell and Mattel</li>
  </ul>  
  </div>
  <hr>
<br>
  </div>
  
  <div class="paragraph">
  <div class="hc-title">BLE Lightsaber Prototype</div>
  In this video, I control a lightsaber's on-screen rotation in a Unity game using a BLE SensorTag affixed to one of our plastic Kellogg's cereal spoons.<br>
  
  <div class="paragraph center">
          <iframe class="youtube" src="https://www.youtube.com/embed/CiPMfnFVKoQ?rel=0" frameborder="0" allowfullscreen></iframe>
      </div>

      </div>
    <hr>
    <br>
          </div>
          
          <div class="paragraph">
          <div class="hc-title">Build-A-Bear Workshop - Hot and Cold Prototype</div>
          I pitched and created an iPad app idea to Build-A-Bear enabling families to play <strong>Hide and Seek</strong> with their plushies.<br><br>
          The was made possible with Estimote's BLE asset from the Unity Asset store and tracking an Estimote beacon embedded inside a Build-A-Bear stuffed animal hidden around the house. The companion iPad app I wrote would show you how close (or far) you were to finding it, with surprising accuracy (< 1m).
          <br><br>
          During development, I also learned that iOS devices functioned as iBeacons right out of the box!

          <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/babw_hotcold1.png" alt="BABW Hide and Seek Screenshot"/>
        <img class="pc-screenshot" src="img/projects/babw_hotcold2.png" alt="BABW Hide and Seek Screenshot"/>
        <img class="pc-screenshot" src="img/projects/babw_hotcold3.png" alt="BABW Hide and Seek Screenshot"/>
        <img class="pc-screenshot" src="img/projects/babw_hotcold4.png" alt="BABW Hide and Seek Screenshot"/>
    </div>
        
</div>

<div style="clear:both"></div>
</div>

</div>
`, "#0c2994"),
  new ProjectData("project-9", "Design, Web, and Multimedia", "img/projects/design4.png", `
     <div class="paragraph">
                I like to leave my design portfolio online because frankly, I was <strong>good at it</strong>. Those 12 years of graphic design laid the foundation for my game dev career. I can help bridge the communication gap between developers, creatives, and project managers. Everyone loves it when you can speak their language.
            <br><br>
            Click the image below to view.
            <div class="paragraph center">
            <a href="https://www.marlonvelasco.com/html5" target="_blank">
            <img src="img/projects/design7.png" alt="Design portfolio" style="width:720px;height:410px;"/>
            </a></div>
    </div>

            <div class="paragraph">
        I can still throw down in most of these (RIP Flash):
        <ul>
        <li>Web Design & Development</li>
        <li>Print and Graphic Design</li>
        <li>Motion graphics</li>
        <li>Fine Art & Illustration</li>
        <li>Retouch</li>
        <li>3D Modeling & Animation</li>
        <li>Flash & Actionscript</li>
        </ul>
    </div>
    `),
  new ProjectData("project-9", "Editor Tools, Animation & System Design", "img/projects/artisttools-icon.png", `
  <div class="hc-title">Custom Editor Tools</div>   
  <div class="paragraph">
                For Happy Meal App, I was responsible for updating the <strong>Learn To Draw</strong> content every month. However, working with its existing tracing component was tedious, especially for more elaborate drawing steps.<br><br>
                Take Moana's dress below for example. I used to have to manually place each node on a Curve which served as an animated line segment that the user had to trace. Leveraging a List for this purpose enabled me to automate this process of adding tracing nodes, by duplicating the existing ones in reverse, in turn guiding the player to finish tracing that particular line segment.
            </div>

            <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/WnipHKUh7Ok?rel=0" frameborder="0" allowfullscreen></iframe>
</div>
<div class="paragraph">
Here's the code (C#):
</div>
            <div class="paragraph center">
            
            <img src="img/projects/artisttools.png" alt="Design portfolio" style="width:720px;height:410px;"/>
            </a></div>
    </div>
    <div class="hc-title">2D Animation</div>   
    <div class="paragraph">
    This shortened the turnaround time for each ensuing Learn to Draw promo and enabled me to focus on its best component: <strong>the payoff animation!</strong>
    </div>

    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/6SEAII_tHEg?rel=0" frameborder="0" allowfullscreen></iframe>
</div>
<br>
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/obzzg6A02Mc?rel=0" frameborder="0" allowfullscreen></iframe>
    </div>
<hr><br>
<div class="hc-title">System Design</div>   
  <div class="paragraph">
                Scriptable object data containers are a neat little mechanism for creating templates for gameobjects. See how easy it is to change out a Match 3 gameboard using scriptable objects linked with prefabs consisting of animals or NFL helmets.<br><br>
                Pressing the Space Bar generates a new grid layout. Note also how the grid squares self-label in the Hierarchy based on their coordinates from (0,0). It's very similar to printing a Multiplication Table.
            </div>

            <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/rS3mTNkn7-M?rel=0" frameborder="0" allowfullscreen></iframe>
</div>
<div class="paragraph">
Scriptable object code:
</div>
            <div class="paragraph center">
            <img src="img/projects/systemdesign2.png" alt="Design portfolio" style="width:720px;height:410px;"/>
            </div>
    </div>

    <div class="paragraph">
C# code that generates the board:
</div>
            <div class="paragraph center">
            <img src="img/projects/systemdesign1.png" alt="Design portfolio" style="width:720px;height:410px;"/>
            </div>
    </div>

    
            </div>`, "#c10606", false, false),

];